export default __webpack_public_path__ + "static/media/style-angelusCourtyardStone.e1213811.jpg";